var _g, _path, _g2, _path2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSso = function SvgSso(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_809_3585)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_809_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 54.4767C47.3961 54.1776 48.0797 54.1753 48.6562 54.4703L75.5213 68.2196C76.973 68.9626 76.973 71.0374 75.5213 71.7804L48.6562 85.5297C48.0797 85.8247 47.3961 85.8224 46.8216 85.5233L20.4081 71.774C18.9727 71.0269 18.9727 68.9731 20.4081 68.226L46.8216 54.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_809_3585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_809_3585)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2141 12)",
    fill: "url(#paint0_linear_809_3585)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6471 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2141 48)",
    fill: "url(#paint1_linear_809_3585)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2721 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0378 30)",
    fill: "url(#paint2_linear_809_3585)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0959 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_809_3585)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_809_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.376 56.418C72.0142 54.7722 73.1351 52.325 73.1351 50.225C73.1351 47.525 71.2383 46.4202 68.9104 47.7642C68.0482 48.262 67.1859 49.0598 66.4962 50.058C65.8927 46.9064 63.3061 45.7998 60.116 47.6416C56.581 49.6825 53.6495 54.775 53.6495 58.875C53.6495 61.275 54.5979 62.8274 56.0637 63.2812",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2031 62.9187C57.6442 65.6187 57.6442 68.4187 59.2031 69.3187C60.7619 70.2187 63.1868 68.8187 64.7456 66.1187C65.9581 64.0187 66.2179 61.8687 65.525 60.5687L68.7293 55.0187L68.7293 52.9187L66.9107 53.9687L63.7064 59.5187C62.2341 59.4687 60.4155 60.8187 59.2031 62.9187Z",
    fill: "url(#paint3_linear_809_3585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2031 62.9187C57.6442 65.6187 57.6442 68.4187 59.2031 69.3187C60.7619 70.2187 63.1868 68.8187 64.7456 66.1187C65.9581 64.0187 66.2179 61.8687 65.525 60.5687L68.7293 55.0187L68.7293 52.9187L66.9107 53.9687L63.7064 59.5187C62.2341 59.4687 60.4155 60.8187 59.2031 62.9187Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1948 65.9685C61.0991 66.0238 61.0216 65.9789 61.0216 65.8685C61.0216 65.758 61.0991 65.6238 61.1948 65.5685",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1947 65.9685C61.2904 65.9133 61.3679 65.7789 61.3679 65.6685C61.3679 65.558 61.2904 65.5133 61.1947 65.5685",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_809_3585",
    x: 3.33154,
    y: 38.2507,
    width: 89.2786,
    height: 63.4987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.960784 0 0 0 0 0.592157 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_809_3585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_809_3585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_809_3585",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0F7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72F38B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_809_3585",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93F6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CB34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_809_3585",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96F6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47F068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_809_3585",
    x1: 68.7293,
    y1: 65.1238,
    x2: 57.8284,
    y2: 59.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_809_3585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_809_3585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 53 51)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_809_3585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 53 51)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSso);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sso.96a834b0ddabe29e7f547a523f601f15.svg";